const importAllSVG = (reqSvgs, name) => {
    return reqSvgs.keys().reduce((images, path) => {
        const pathKey = `${path.replace('./', '').replace('.svg', '')}${name}`;
        return Object.assign(Object.assign({}, images), { [pathKey]: reqSvgs(path) });
    }, {});
};
const reqSvgsOutlined = require.context('./outlined', true, /\.svg$/);
const reqSvgsRounded = require.context('./rounded', true, /\.svg$/);
const reqSvgsSpecial = require.context('./special', true, /\.svg$/);
const reqSvgsFilled = require.context('./filled', true, /\.svg$/);
export const svgsOutlined = importAllSVG(reqSvgsOutlined, 'Outlined');
export const svgsRounded = importAllSVG(reqSvgsRounded, 'Rounded');
export const svgsSpecial = importAllSVG(reqSvgsSpecial, 'Special');
export const svgsFilled = importAllSVG(reqSvgsFilled, 'Filled');
export const Icons = Object.assign(Object.assign(Object.assign(Object.assign({}, svgsOutlined), svgsRounded), svgsSpecial), svgsFilled);
//# sourceMappingURL=index.js.map